import React from 'react';
import classnames from 'classnames';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';

import i18n from 'i18next';

import { Button, ButtonGroup } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';

import styles from '../styles/initiativeWizardFooter.module.scss';

const InitiativeWizardFooter = ({
  canNavigate,
  canSubmit,
  currentIndex,
  isSubmitting,
  nextPage,
  onNavigateButtonClick,
  onSubmitButtonClick,
  previousPage,
}) => (
  <div className={styles.element}>
    {isSubmitting ? <Loading className={styles.loader} /> : (
      <ButtonGroup className={styles.buttons}>
        <Button
          className={classnames(styles.button, styles.navigateButton, {
            [styles.isHidden]: !previousPage,
          })}
          color="brand"
          icon={<ArrowBack sx={{ height: 18, width: 18 }} />}
          onClick={() => onNavigateButtonClick(currentIndex - 1)}
          text={previousPage?.title}
          variant="outlined"
        />
        {nextPage ? (
          <Button
            className={classnames(styles.button, styles.navigateButton)}
            color="brand"
            icon={<ArrowForward sx={{ height: 18, width: 18 }} />}
            iconPosition="right"
            isDisabled={!canNavigate}
            onClick={() => onNavigateButtonClick(currentIndex + 1)}
            text={nextPage.title}
            variant="outlined"
          />
        ) : (
          <Button
            className={classnames(styles.button, styles.submitButton)}
            color="brand"
            isDisabled={!canSubmit}
            onClick={onSubmitButtonClick}
            text={i18n.t('save-initiative')}
          />
        )}
      </ButtonGroup>
    )}
  </div>
);

export default React.memo(InitiativeWizardFooter);
